export { ComponenteTabsWeb } from "./ComponenteTabsWeb";
